import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ArrowLeft } from "lucide-react";
import Planning from "@/pages/Planning";
import Admin from "@/pages/Admin";
import { useSettings } from "@/lib/settings";

function Layout({ children }) {
  const { settings } = useSettings();
  const showBack = settings?.back_button_enabled && settings?.back_button_url;

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
            <div className="w-10 h-10 rounded-full bg-[#0b3a73] text-white flex items-center justify-center font-serif text-lg">F</div>
            <div>
              <div className="font-serif text-xl tracking-tight text-[#0b3a73]">Fête du Port</div>
              <div className="text-xs text-slate-500 uppercase tracking-widest">Inscription bénévoles</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            {showBack && (
              <a
                href={settings.back_button_url}
                rel="noopener"
                data-testid="back-button"
                className="inline-flex items-center gap-1.5 text-sm text-[#0b3a73] border border-[#0b3a73]/30 hover:border-[#0b3a73] hover:bg-[#0b3a73] hover:text-white rounded-full px-3 py-1.5 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                {settings.back_button_text || "Retour"}
              </a>
            )}
            <Link
              to="/admin"
              data-testid="header-admin-link"
              className="text-sm text-slate-600 hover:text-[#0b3a73] underline-offset-4 hover:underline transition-colors"
            >
              Espace admin
            </Link>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">{children}</main>
      <footer className="border-t border-slate-200 py-6 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-xs text-slate-500 text-center">
          Club Nautique – Fête du Port · Merci à tous les bénévoles ⚓
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><Planning /></Layout>} />
        <Route path="/admin" element={<Layout><Admin /></Layout>} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
